'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.omitProps = exports.defaultFieldPropTypes = exports.fieldPropTypes = exports.optionsPropTypes = undefined;
var _propTypes = require('prop-types');
var _format = require('@marmalade/format');
var optionsPropTypes = exports.optionsPropTypes = (0, _propTypes.arrayOf)((0, _propTypes.oneOfType)([_propTypes.string, (0, _propTypes.shape)({
  value: _propTypes.string,
  text: _propTypes.string
})]));
var fieldPropTypes = exports.fieldPropTypes = {
  // user
  name: _propTypes.string.isRequired,
  label: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.node]),
  helpText: _propTypes.string,
  disabled: _propTypes.bool,
  format: (0, _propTypes.oneOfType)([(0, _propTypes.oneOf)(_format.formatTypes), (0, _propTypes.arrayOf)((0, _propTypes.oneOf)(_format.formatTypes))]),
  extra: _propTypes.node,
  // stateToProps
  value: _propTypes.string,
  error: _propTypes.string,
  validating: _propTypes.bool,
  // dispatchToProps
  control: _propTypes.func,
  validate: _propTypes.func,
  fieldCss: _propTypes.object
};
var defaultFieldPropTypes = exports.defaultFieldPropTypes = {
  value: undefined,
  label: undefined,
  error: undefined,
  helpText: undefined,
  disabled: false,
  validating: false,
  control: undefined,
  validate: undefined,
  fieldCss: undefined,
  format: undefined,
  extra: undefined
};
var omitProps = exports.omitProps = ['formId', 'control', 'validate', 'setResult', 'reset', 'resetText', 'helpText'];